var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleStoreBtnFooter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 41,
    viewBox: "0 0 140 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.044 40.2134H5.15556C2.32129 40.2134 0 37.9501 0 35.1867V5.02671C0 2.2633 2.32129 4.673e-05 5.15556 4.673e-05H134.044C136.879 4.673e-05 139.2 2.2633 139.2 5.02671V35.1867C139.2 37.9501 136.879 40.2134 134.044 40.2134Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M134.044 0.805568C136.431 0.805568 138.374 2.69937 138.374 5.02671V35.1867C138.374 37.5141 136.431 39.4079 134.044 39.4079H5.15556C2.76853 39.4079 0.826177 37.5141 0.826177 35.1867V5.02671C0.826177 2.69937 2.76853 0.805568 5.15556 0.805568H134.044ZM134.044 4.673e-05H5.15556C2.32129 4.673e-05 0 2.2633 0 5.02671V35.1867C0 37.9501 2.32129 40.2134 5.15556 40.2134H134.044C136.879 40.2134 139.2 37.9501 139.2 35.1867V5.02671C139.2 2.2633 136.879 4.673e-05 134.044 4.673e-05Z",
    fill: "#A6A6A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7597 7.57921C10.4568 7.88835 10.2815 8.36965 10.2815 8.99296V31.2259C10.2815 31.8492 10.4568 32.3305 10.7597 32.6397L10.8344 32.7075L23.6125 20.254V19.9599L10.8344 7.50633L10.7597 7.57921Z",
    fill: "url(#paint0_linear_6193_4508)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8672 24.4072L23.6125 20.2539V19.9599L27.8723 15.8066L27.9677 15.8606L33.0124 18.6592C34.4521 19.4534 34.4521 20.7604 33.0124 21.5596L27.9677 24.3532L27.8672 24.4072Z",
    fill: "url(#paint1_linear_6193_4508)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9677 24.3532L23.6126 20.1069L10.7598 32.6396C11.2379 33.1297 12.0177 33.1888 12.9045 32.6987L27.9677 24.3532Z",
    fill: "url(#paint2_linear_6193_4508)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9677 15.8607L12.9045 7.51514C12.0177 7.03006 11.2379 7.08913 10.7598 7.57923L23.6126 20.1069L27.9677 15.8607Z",
    fill: "url(#paint3_linear_6193_4508)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8926 10.2986C48.8926 11.1381 48.6348 11.8104 48.127 12.3118C47.5431 12.9062 46.7827 13.2053 45.8508 13.2053C44.9602 13.2053 44.1998 12.9012 43.5759 12.3017C42.9508 11.6935 42.6389 10.9471 42.6389 10.0536C42.6389 9.16008 42.9508 8.41363 43.5759 7.81043C44.1998 7.20597 44.9602 6.90186 45.8508 6.90186C46.2942 6.90186 46.717 6.99108 47.1204 7.15696C47.5225 7.3241 47.8499 7.5503 48.087 7.82927L47.5483 8.35959C47.1346 7.88331 46.5713 7.64832 45.8508 7.64832C45.2012 7.64832 44.638 7.86949 44.1598 8.3156C43.6868 8.76298 43.4496 9.3423 43.4496 10.0536C43.4496 10.7648 43.6868 11.3492 44.1598 11.7966C44.638 12.2377 45.2012 12.4639 45.8508 12.4639C46.5404 12.4639 47.1204 12.2377 47.5779 11.7915C47.8795 11.4962 48.051 11.0891 48.0961 10.5688H45.8508V9.84245H48.8462C48.8823 9.99954 48.8926 10.1516 48.8926 10.2986Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6448 7.78022H50.8312V9.69035H53.3677V10.4167H50.8312V12.3268H53.6448V13.067H50.0347V7.04004H53.6448V7.78022Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9984 13.067H56.2019V7.78022H54.4761V7.04004H58.7255V7.78022H56.9984V13.067Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8008 13.067V7.04004H62.596V13.067H61.8008Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1212 13.067H65.3311V7.78022H63.5989V7.04004H67.8535V7.78022H66.1212V13.067Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8986 12.2917C75.2889 12.9012 74.5336 13.2053 73.6327 13.2053C72.7266 13.2053 71.9713 12.9012 71.3617 12.2917C70.7533 11.6835 70.4504 10.937 70.4504 10.0536C70.4504 9.17014 70.7533 8.42368 71.3617 7.81545C71.9713 7.20597 72.7266 6.90186 73.6327 6.90186C74.5285 6.90186 75.2838 7.20597 75.8934 7.82048C76.5069 8.43373 76.8098 9.17516 76.8098 10.0536C76.8098 10.937 76.5069 11.6835 75.8986 12.2917ZM71.9507 11.7865C72.4096 12.2377 72.9676 12.4639 73.6327 12.4639C74.2926 12.4639 74.8559 12.2377 75.3096 11.7865C75.7671 11.3354 75.9991 10.7561 75.9991 10.0536C75.9991 9.3511 75.7671 8.77178 75.3096 8.32063C74.8559 7.86949 74.2926 7.64329 73.6327 7.64329C72.9676 7.64329 72.4096 7.86949 71.9507 8.32063C71.4932 8.77178 71.2612 9.3511 71.2612 10.0536C71.2612 10.7561 71.4932 11.3354 71.9507 11.7865Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9275 13.067V7.04004H78.8942L81.8998 11.7274H81.9346L81.8998 10.5688V7.04004H82.6951V13.067H81.865L78.7176 8.14842H78.6828L78.7176 9.31209V13.067H77.9275Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2548 21.8685C67.833 21.8685 65.8546 23.6656 65.8546 26.145C65.8546 28.6043 67.833 30.4202 70.2548 30.4202C72.6818 30.4202 74.6603 28.6043 74.6603 26.145C74.6603 23.6656 72.6818 21.8685 70.2548 21.8685ZM70.2548 28.7362C68.926 28.7362 67.7828 27.6668 67.7828 26.145C67.7828 24.6031 68.926 23.5525 70.2548 23.5525C71.5837 23.5525 72.7321 24.6031 72.7321 26.145C72.7321 27.6668 71.5837 28.7362 70.2548 28.7362ZM60.6539 21.8685C58.2269 21.8685 56.2536 23.6656 56.2536 26.145C56.2536 28.6043 58.2269 30.4202 60.6539 30.4202C63.0796 30.4202 65.0542 28.6043 65.0542 26.145C65.0542 23.6656 63.0796 21.8685 60.6539 21.8685ZM60.6539 28.7362C59.3238 28.7362 58.1767 27.6668 58.1767 26.145C58.1767 24.6031 59.3238 23.5525 60.6539 23.5525C61.9828 23.5525 63.126 24.6031 63.126 26.145C63.126 27.6668 61.9828 28.7362 60.6539 28.7362ZM49.2292 23.1792V24.9964H53.6797C53.5496 26.0118 53.2016 26.7582 52.668 27.2785C52.0184 27.9068 51.0066 28.6043 49.2292 28.6043C46.4903 28.6043 44.3456 26.4491 44.3456 23.7787C44.3456 21.1083 46.4903 18.9531 49.2292 18.9531C50.7101 18.9531 51.7876 19.5173 52.5829 20.2487L53.8963 18.9682C52.784 17.9327 51.3043 17.1372 49.2292 17.1372C45.4734 17.1372 42.3169 20.1168 42.3169 23.7787C42.3169 27.4406 45.4734 30.4202 49.2292 30.4202C51.2592 30.4202 52.784 29.7717 53.9826 28.5553C55.2109 27.3577 55.5937 25.6737 55.5937 24.314C55.5937 23.8918 55.5576 23.5035 55.4932 23.1792H49.2292ZM95.9463 24.588C95.5841 23.6316 94.4666 21.8685 92.1904 21.8685C89.9349 21.8685 88.057 23.6015 88.057 26.145C88.057 28.5402 89.9155 30.4202 92.407 30.4202C94.4215 30.4202 95.5841 29.2226 96.0623 28.5251L94.5671 27.5537C94.0683 28.265 93.3891 28.7362 92.407 28.7362C91.4313 28.7362 90.7314 28.3002 90.2829 27.4406L96.1486 25.0743L95.9463 24.588ZM89.9658 26.0118C89.9155 24.363 91.2792 23.5186 92.2562 23.5186C93.0218 23.5186 93.6714 23.8918 93.8879 24.4259L89.9658 26.0118ZM85.1982 30.16H87.1264V17.5934H85.1982V30.16ZM82.0404 22.8211H81.976C81.5429 22.3209 80.7168 21.8685 79.6702 21.8685C77.4739 21.8685 75.4658 23.7485 75.4658 26.1588C75.4658 28.5553 77.4739 30.4202 79.6702 30.4202C80.7168 30.4202 81.5429 29.964 81.976 29.4488H82.0404V30.062C82.0404 31.6969 81.1447 32.5753 79.6998 32.5753C78.5218 32.5753 77.791 31.7459 77.4894 31.0485L75.8125 31.7309C76.2959 32.8644 77.5757 34.2593 79.6998 34.2593C81.9605 34.2593 83.8681 32.9624 83.8681 29.8069V22.1287H82.0404V22.8211ZM79.8352 28.7362C78.5063 28.7362 77.394 27.6517 77.394 26.1588C77.394 24.6521 78.5063 23.5525 79.8352 23.5525C81.1447 23.5525 82.1771 24.6521 82.1771 26.1588C82.1771 27.6517 81.1447 28.7362 79.8352 28.7362ZM104.974 17.5934H100.362V30.16H102.285V25.3985H104.974C107.109 25.3985 109.204 23.8918 109.204 21.4953C109.204 19.1001 107.104 17.5934 104.974 17.5934ZM105.024 23.6505H102.285V19.3414H105.024C106.46 19.3414 107.279 20.5038 107.279 21.4953C107.279 22.468 106.46 23.6505 105.024 23.6505ZM116.911 21.8447C115.522 21.8447 114.077 22.4428 113.483 23.7686L115.189 24.4661C115.557 23.7686 116.232 23.5424 116.946 23.5424C117.944 23.5424 118.955 24.1268 118.971 25.1585V25.2904C118.623 25.0944 117.878 24.8041 116.962 24.8041C115.124 24.8041 113.251 25.7906 113.251 27.6316C113.251 29.3156 114.756 30.4001 116.449 30.4001C117.743 30.4001 118.457 29.8308 118.905 29.1685H118.971V30.1399H120.828V25.3194C120.828 23.0913 119.122 21.8447 116.911 21.8447ZM116.679 28.7312C116.05 28.7312 115.174 28.4271 115.174 27.6668C115.174 26.6941 116.267 26.3209 117.213 26.3209C118.06 26.3209 118.457 26.5031 118.971 26.7432C118.82 27.9068 117.793 28.7312 116.679 28.7312ZM127.595 22.1199L125.384 27.5675H125.319L123.034 22.1199H120.96L124.393 29.7328L122.434 33.969H124.444L129.734 22.1199H127.595ZM110.261 30.16H112.189V17.5934H110.261V30.16Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6193_4508",
    x1: 22.4779,
    y1: 31.4574,
    x2: 5.61143,
    y2: 14.1585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6193_4508",
    x1: 34.8871,
    y1: 20.1055,
    x2: 9.93744,
    y2: 20.1055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6193_4508",
    x1: 25.5995,
    y1: 17.7986,
    x2: 2.72717,
    y2: -5.66024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6193_4508",
    x1: 7.52445,
    y1: 40.0365,
    x2: 17.738,
    y2: 29.5611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleStoreBtnFooter);
export default __webpack_public_path__ + "static/media/googleStoreBtnFooter.3334e61e768867bb9a018cca33b7a535.svg";
export { ForwardRef as ReactComponent };